import { useContext, useEffect, useState } from "react";
import cn from "classnames";
import { motion } from "framer-motion";
import Header from "../layouts/_header";
import Sidebar from "../layouts/_layout_sidebar";
import useAuth from "../hooks/use-auth";
import { useLocation, useNavigate } from "react-router-dom";
import routes from "../config/routes";
import Alert from "../components/ui/alert";
import GlobalContext from "../context/global-context";

export default function Layout({ children }: React.PropsWithChildren<{}>) {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  let [collapse, setCollapse] = useState(false);
  const { isAuthorized } = useAuth();

  const { isAlertOpened, setIsAlertOpened, alertText } =
    useContext(GlobalContext);

  useEffect(() => {
    updateWindowSize();
    window.addEventListener("resize", updateWindowSize);
    return () => window.removeEventListener("resize", updateWindowSize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (isAuthorized) {
      setCollapse(false);
    }
  }, [isAuthorized]);

  function updateWindowSize() {
    setIsMobile(false);
    if (window.innerWidth >= 640) {
      setCollapse(false);
    } else {
      setIsMobile(true);
    }
  }

  function toggleSidebar() {
    setCollapse((prev) => !prev);
  }

  return (
    <motion.div
      initial="exit"
      animate="enter"
      exit="exit"
      className="scrollbar-hide flex min-h-screen w-full flex-col bg-light dark:bg-dark-100"
    >
      <Header
        isCollapse={collapse}
        showHamburger={isAuthorized}
        onClickHamburger={toggleSidebar}
      />
      <div className="flex flex-1">
        {isAuthorized && (
          <Sidebar isCollapse={collapse} setCollapse={setCollapse} />
        )}
        <main
          className={cn(
            "flex w-full flex-col bg-light-300",
            isAuthorized
              ? collapse
                ? "sm:pl-60 xl:pl-[75px]"
                : "sm:pl-[75px] xl:pl-72"
              : ""
          )}
        >
          {children}
        </main>
      </div>
      <Alert
        isOpened={isAlertOpened}
        setIsOpened={setIsAlertOpened}
        text={alertText}
      />
    </motion.div>
  );
}
